module.exports = __webpack_public_path__ + "static/media/ET029 new.17a2cce6.jpg";